export default "__VITE_ASSET__BELz7q1f__"